import { WithPageSize } from './filters';

export enum ReportType {
  Task = 'task',
  Capacity = 'capacity',
}

export enum ReportFormat {
  Excel = 'xlsx',
  CSV = 'csv',
}
//response of create report task API
export interface ExportReportResponse {
  success: boolean;
  message: string;
}

//for generalizing the logic for diff types of formats and reports
export interface UseExportReportOptions<TFilter> {
  reportType: ReportType;
  format?: ReportFormat;
  filterQuery: TFilter;
  onSuccess?: () => void;
  onError?: (msg: string) => void;
}

//response of the create task HOOK
export interface UseExportReportReturn {
  exportReport: (fileName: string) => Promise<void>;
  isExporting: boolean;
  error: string | null;
}

//request of create task report
export interface ExportReportRequest<TFilter> {
  userId: string;
  reportType: ReportType;
  fileName: string;
  format: ReportFormat;
  filterQuery: TFilter;
}

//For Reports page

//request for get reports by userID
export interface ReportsInfoRequest {
  userId: string;
  expand?: boolean;
  filter: ReportsListFilter;
}

export interface BaseReportsFilter {
  reportTypes?: ReportType[];
  isNotified?: boolean;
  status?: string[];
}

export type ReportsListFilter = WithPageSize & BaseReportsFilter;

//grid model
export interface ReportGridInfo {
  id: string;
  fileName: string;
  createdAt: string; // ISO string
  expiresAt: string; // ISO string
  status: string;
  url: string | null; // URL to download the report
}

//response for get reports by userID for REPORTS PAGE
export interface GetReportsByIdResponseInfo {
  id: string;
  reportType: ReportType;
  instanceId?: string;
  userId: string;
  fileName: string;
  filterQuery: string;
  status: string;
  createdAt: string;
  lastUpdatedTime: string;
  isNotified: boolean;
  error?: {
    code: string;
    message: string;
    correlationId: string;
  };
  report?: {
    expiresAt: string;
    url: string;
    format: 'excel';
  };
}

//response for get reports by userID for polling
export interface UnNotifiedReportsResponse {
  id: string;
  status: string;
  isNotified: boolean;
}

//for marking reports as notified
export interface MarkReportsAsNotified {
  id: string;
  isNotified: boolean;
}

export interface MarkReportsAsNotifiedResponse {
  success: boolean;
  message: string;
}
